module.exports = "/packs/media/images/icons/icon_inyourwords-7cce25e7ad2c2294ec1fd5275fc939c7.png";